import React from 'react'
import { Link } from 'react-router-dom'

export const TopMenuLink = ({ text, url,onClicked }) => {
    url = url || '';
    const isAbsUrl = url.toLowerCase().startsWith('http')
    return (
        <div>
            {isAbsUrl ? (
                <a href={url} target='_blank' onClick={()=>onClicked(false)}>{text}</a>
            ) : (

                    <Link to={url} onClick={() => onClicked(false)} >{text}</Link>
                )}
        </div>
    )
}
